import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AppController } from 'presentation/app.controller';

@Component({
	selector: 'spr-page-with-title',
	templateUrl: './page-with-title.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'flex flex-col p-background-color-component-colored-background',
	},
})
export class PageWithTitleComponent {
	public i18n = 'presentation.common.component.page-with-title';
	@Input() public title: string;

	@Input() public styleClass: string;

	constructor(public appController: AppController) {}
}
